export enum POLineStatus {
  ACTIVE = 'ACTIVE',
  PAID = 'PAID',
  COMPLETED = 'COMP',
  CANCELLED = 'CANCEL',
}
